import { render, staticRenderFns } from "./loanPaymentSummary.vue?vue&type=template&id=12d13920&scoped=true"
import script from "./loanPaymentSummary.vue?vue&type=script&lang=js"
export * from "./loanPaymentSummary.vue?vue&type=script&lang=js"
import style0 from "./loanPaymentSummary.vue?vue&type=style&index=0&id=12d13920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d13920",
  null
  
)

export default component.exports